import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "oc-res-organization",
  "use": "oc-res-organization-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"oc-res-organization\"><path d=\"M908 895.9V351.5L628 240.6V64H116v831.9H64V960h896v-64.1h-52z m-728 0V128.1h384v767.7H180z m448 0V309.6l216 85.6v500.7H628z\" /><path d=\"M232 179.3h112v110.9H232zM232 401.1h112V512H232zM232 622.9h112v110.9H232zM400 179.3h112v110.9H400zM680 456.5h112v110.9H680zM680 678.4h112v110.9H680zM400 401.1h112V512H400zM400 622.9h112v110.9H400z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol